/**
 * Test IDs for QA automation.
 */
export const testIds = {
  customFieldDefinitionFormLabel: "custom-field-definition-form-label",
  customFieldDefinitionFormOptionsNavigation: "custom-field-definition-form-options-navigation",
  customFieldDefinitionFormPredefinedOptions: "custom-field-definition-form-predefined-options",
  customFieldDefinitionFormListOptions: "custom-field-definition-form-list-options",
  customFieldDefinitionFormOption: "custom-field-definition-form-option",
  customFieldDefinitionFormRemoveOption: "custom-field-definition-form-remove-option",
  customFieldDefinitionFormIsHardRequirement: "custom-field-definition-form-is-hard-requirement",
  customFieldDefinitionFormIsRequired: "custom-field-definition-form-is-required",
  customFieldDefinitionFormIsPartial: "custom-field-definition-form-is-partial",
  customFieldDefinitionFormSaveToggle: "custom-field-definition-form-save-toggle",
  customFieldDefinitionFormSave: "custom-field-definition-form-save",
} as const;
